import { AdminCountDto } from '../generated-types/adminCountDto';
import { AbstractApi } from './AbstractApi';

/**
 * An API to handle admin requests.
 */
export default class ArticlesApi extends AbstractApi {
  /**
   * Get the counts for the dashboard
   * @returns The counts for the dashboard
   */
  async GetCounts(): Promise<AdminCountDto> {
    const response = await this.authFetch(this.BuildUrl('admin/counts'), {
      method: 'GET',
    });

    if (!response.ok) throw Error();

    return (await response.json()) as unknown as AdminCountDto;
  }
}
